import React from 'react';
import PropTypes from 'prop-types';
import Store from '@app/store';
import Browser from '@wetransfer/concorde-browser';

import Config from '@component/navigation/config';
import VerticalNav from '@component/navigation/verticalnav';

import AdvertiseBrands from '@app/page/advertise/brands';

export default class Advertise extends React.Component {
  static propTypes = {
    route: PropTypes.object,
  };

  render() {
    const { route } = Store.getState();

    const brands = <AdvertiseBrands />;

    const menuItems = Config.getAdvertisePageItems();

    let menu = null;
    let itemsToRender = [];
    let sectionsAreStacked = false;

    if (!Browser.isMobile) {
      // In case of a non mobile device the sections are accessible through a vertical nav
      // Hide menu if active page is hidden
      menu = (
        <div className="advertise--nav">
          <VerticalNav
            items={menuItems}
            activeItem={route.path}
            sticky={false}
          />
        </div>
      );

      itemsToRender.push(menuItems.find((item) => item.href === route.path));
    } else if (
      this.props.route.path === '/advertise/guidelines' ||
      this.props.route.path === '/advertise/gallery' ||
      this.props.route.path === '/advertise/contact'
    ) {
      itemsToRender.push(menuItems.find((item) => item.href === route.path));
    } else {
      itemsToRender = menuItems.filter((item) => !item.hiddenOnMobile);
      sectionsAreStacked = true;
    }

    // Render all the required sections
    const contentChildren = [];
    itemsToRender.forEach((item, key) => {
      if (!item) {
        return;
      }

      if (item.component) {
        contentChildren.push(
          React.createElement(item.component, {
            ...this.props,
            ...item.options,
            key: `advertise_item_${item.href}`,
          })
        );
      }

      // The horizontal line separating sections
      if (
        sectionsAreStacked &&
        itemsToRender.length > 1 &&
        key !== itemsToRender.length - 1
      ) {
        contentChildren.push(
          React.createElement('hr', { key: `advertise_hr_${item.href}` })
        );
      }
    });

    if (Browser.isMobile) {
      return (
        <div>
          {contentChildren}
          {brands}
        </div>
      );
    }

    return (
      <div>
        <div className="row">
          <div className="col">{contentChildren}</div>
          <div className="col">{menu}</div>
        </div>
        <div className="row">{brands}</div>
      </div>
    );
  }
}
